import { render, staticRenderFns } from "./ExitModal.vue?vue&type=template&id=886ef7a6"
import script from "./ExitModal.vue?vue&type=script&lang=js"
export * from "./ExitModal.vue?vue&type=script&lang=js"
import style0 from "./ExitModal.vue?vue&type=style&index=0&id=886ef7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports